<script setup lang="ts">
import { ref } from 'vue'
import FbBanner from '@/components/ui/FbBanner.vue'
import { useApiHealth } from '@/composables/useApiHealth'

const { isApiUnreachable } = useApiHealth()
const retrying = ref(false)

function handleRetry() {
  retrying.value = true
  window.location.reload()
}
</script>

<template>
  <FbBanner
    v-if="isApiUnreachable"
    tone="error"
    icon="mdi-alert-circle-outline"
    data-testid="api-unreachable-banner"
  >
    Can't reach Fam-Bam right now.
    <template #actions>
      <v-btn
        variant="text"
        data-testid="api-unreachable-retry"
        :loading="retrying"
        @click="handleRetry"
      >
        Try again
      </v-btn>
    </template>
  </FbBanner>
</template>
